import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FinalCTA = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const img = new Image();
    img.src = "/images/gallery/ext.jpg";
    img.onload = () => setIsImageLoaded(true);
  }, []);

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-ink">
      <div className="absolute inset-0 z-0">
        {isImageLoaded ? (
          <motion.div
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: "url('/images/gallery/ext.jpg')" }}
            initial={{ scale: 1.08 }}
            animate={{ scale: 1 }}
            transition={{ duration: 6, ease: "easeOut" }}
          />
        ) : (
          <div className="w-full h-full bg-ink-soft animate-pulse" />
        )}
      </div>

      <div className="absolute inset-0 z-[1] bg-ink/45" />
      <div className="absolute inset-0 z-[1] bg-gradient-to-t from-ink/70 via-transparent to-ink/30" />

      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        <motion.span
          className="eyebrow text-brass-light block mb-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {t("labels.reserve")}
        </motion.span>

        <motion.h2
          className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-wide mb-8"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.8 }}
        >
          {t("finalCTA.title")}
        </motion.h2>

        <motion.div
          className="w-16 h-px bg-brass-light mx-auto mb-8"
          initial={{ width: 0 }}
          whileInView={{ width: 64 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.8 }}
        />

        <motion.p
          className="text-base md:text-lg text-white/80 mb-12 max-w-md mx-auto leading-relaxed font-light"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.45, duration: 0.8 }}
        >
          {t("finalCTA.subtitle")}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <Link
            to="/booking"
            className="inline-flex items-center justify-center bg-brass hover:bg-brass-dark text-ink text-[12px] uppercase tracking-[0.22em] py-4 px-12 transition-colors duration-300"
          >
            {t("finalCTA.reserveButton")}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
